import React, { useState, useEffect } from 'react'
import ProductService from '../../../../../../services/api/product.service'
import APIResponse from '../../../../../templates/components/APIResponse'
import ProductTagForm from './ProductTagForm'
import DimLoader from '../../../../../templates/components/DimLoader'

const AddProductTag = (props) => {
    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const submitHandler = (reqObj) => {
        setIsLoader(true)
        return ProductService.addcustomTags(reqObj)
            .then(res => {
                setApiResponse(res);
            })
            .catch(err => {
                setApiResponse(err);
            }).finally(() => {
                setIsLoader(false)
            });
    }
    return (
        <>{isLoader? <DimLoader loadMessage="Saving"/>:null}
            <ProductTagForm
                onClose={props.onClose} 
                initialData={props.initialData}
                submitHandler={submitHandler} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default AddProductTag